import { inject, Injectable } from "@angular/core";
import { CanActivate } from "@angular/router";
import { DeepLinkService } from "@shared/services/deeplink/deeplink.service";

@Injectable({
	providedIn: "root"
})
export class DeepLinkGuard implements CanActivate {
	private deepLinkService = inject(DeepLinkService);

	canActivate(): boolean {
		// for when user is already authenticated
		this.deepLinkService.preserveDeepLinkFromUrl();
		return true; // Always allow navigation
	}
}
